<template>
  <DataImportModule import-url="/workspace/manager/status/change/procedure/batch/suspend"
                    inline
                    v-bind="$attrs"
                    v-on="$listeners"></DataImportModule>
</template>

<script>
import DataImportModule from '../../../../../../../../elements/DataImportModule'
export default {
  name: 'StatusChangeProcedureBatchSuspend',
  components: {
    DataImportModule
  }
}
</script>
